import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function initCarouselScrollAnimations() {
  const html = document.querySelector("html");
  const headerElement = document.querySelector("header")

  const getPanelElements = (panel) => ({
    indicator: panel.querySelector('.indicator'),
    slidesContainer: panel.querySelector('.slides'),
  });

  let mm = gsap.matchMedia();

  // Defining triggers outside so the wheel listener can read them
  let st;  // The animation trigger (controls progress)
  let st2; // The container trigger (controls active state)

  const panels = gsap.utils.toArray(".carousel-panel");

  const transitionSlide = (panel, nextSlide) => {
    const { indicator, slidesContainer } = getPanelElements(panel);
    const activeSlide = panel.querySelector('.slide.active');
    const clickedTitle = nextSlide.querySelector('h3');
    const clickedTextContainer = nextSlide.querySelector('p').parentNode;
    const clickedImage = panel.querySelector(`.image-container .${nextSlide.className.split(' ').find(cls => cls.startsWith('slide-'))}`);

    const clickTimeline = gsap.timeline({
      defaults: {
        duration: 0.3,
        ease: 'cubic-bezier(.5,-0.53,.14,1.23)',
      },
      onComplete: () => {
        gsap.utils.toArray('.slide, .image-container .group', panel).forEach(el => el.classList.remove('active'));
        nextSlide.classList.add('active');
        if (clickedImage) {
          clickedImage.classList.add('active');
        }
      }
    });

    if (activeSlide && activeSlide !== nextSlide) {
      const activeTextContainer = activeSlide.querySelector('p').parentNode;
      clickTimeline.to(activeTextContainer, { gridTemplateRows: '0fr', opacity: 0 }, 0);
    }

    clickTimeline.to(clickedTextContainer, {
      gridTemplateRows: '1fr',
      opacity: 1,
      onComplete: () => {
        gsap.to(indicator, {
          height: clickedTitle.offsetHeight,
          y: clickedTitle.offsetTop - slidesContainer.offsetTop,
          duration: 0.3,
          ease: 'cubic-bezier(.5,-0.53,.14,1.23)',
        });
      }
    }, activeSlide ? 0 : 0.3);
  };


  panels.forEach((panel) => {
    const { indicator, slidesContainer } = getPanelElements(panel);
    const textContainers = gsap.utils.toArray('.slide > div', panel);
    const slides = gsap.utils.toArray('.slide', panel);
    const initialActiveSlide = panel.querySelector('.slide.active');
    let autoInterval;

    gsap.set(textContainers, { gridTemplateRows: '0fr', opacity: 0 });

    if (initialActiveSlide) {
      const initialTextContainer = initialActiveSlide.querySelector('p').parentNode;
      const initialTitle = initialActiveSlide.querySelector('h3');

      gsap.set(initialTextContainer, { gridTemplateRows: '1fr', opacity: 1 });
      gsap.set(indicator, {
        height: initialTitle.offsetHeight,
        y: initialTitle.offsetTop - slidesContainer.offsetTop,
      });
    } else if (slides.length > 0) {
      slides[0].classList.add('active');
      transitionSlide(panel, slides[0]);
    }


    panel.addEventListener('click', (e) => {
      const clickedTitle = e.target.closest('h3');
      if (clickedTitle) {
        const clickedSlide = clickedTitle.parentNode;

        if (autoInterval) clearInterval(autoInterval);

        transitionSlide(panel, clickedSlide);
      }
    });


    const startAutoCycle = () => {
      if (autoInterval) clearInterval(autoInterval);

      autoInterval = setInterval(() => {
        const activeSlide = panel.querySelector('.slide.active');

        let nextSlide = activeSlide ? activeSlide.nextElementSibling : slides[0];

        if (!nextSlide || !nextSlide.classList.contains('slide')) {
          nextSlide = slides[0];
        }

        transitionSlide(panel, nextSlide);

      }, 8000);
    };

    startAutoCycle();
  });

  mm.add("(min-width: 1300px)", () => {
    const headerHeight = headerElement ? headerElement.offsetHeight : 92;

    const animation = gsap.to(".carousel-pannels", {
      xPercent: -100 + 100 / panels.length,
      duration: 5,
      ease: "none"
    });

    st = ScrollTrigger.create({
      trigger: ".carousel-pannels-pin",
      start: `top ${headerHeight + 120}`,
      endTrigger: ".end",
      end: "bottom 100%",
      pin: true,
      animation: animation,
      scrub: 1,
      // snap: {
      //   snapTo: 1 / (panels.length - 1),
      //   duration: 0.5,
      //   ease: "power2.inOut",
      // }
    });

    const stTitle = ScrollTrigger.create({
      trigger: "#section-title",
      start: `top ${headerHeight + 40}px`,
      endTrigger: ".end",
      end: "bottom 100%",
      pin: true,
      pinSpacing: false,
    });

    st2 = ScrollTrigger.create({
      trigger: ".horizontal-container",
      start: `top ${headerHeight + 90}`,
      endTrigger: ".end",
      end: "bottom 110%",
    });
  });

  window.addEventListener("resize", () => {
    setTimeout(() => {
      ScrollTrigger.refresh(true);
    }, 50);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initCarouselScrollAnimations();
});